import React from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { login } from './../actions/user'

import Header from './../components/Header'

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };
    this.signIn.bind(this)
  }
  signIn() {
    console.log("login")
    this.props.login(this.state.email, this.state.password)
  }
  handleSubmit(event) {
    event.preventDefault()
    this.signIn()
  }
  render() {
    return (<div>
      <section className="hero is-blue-gem-2">
        <Header/>
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">
              Login
            </h1>
            <h2 className="subtitle">
              Find parking spots!
            </h2>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-half">
              <form className="box" onSubmit={this.handleSubmit.bind(this)}>
                <p className="subtitle is-4 has-text-centered">
                  Welcome back!
                  </p>
                <div className="field">
                  <p className="control has-icons-left has-icons-right">
                    <input className="input" type="email" placeholder="Email" value={this.state.email}
                        onChange={(e) => this.setState({email: e.target.value})} />
                    <span className="icon is-small is-left">
                      <i className="fas fa-envelope"></i>
                    </span>
                    <span className="icon is-small is-right">
                      <i className="fas fa-check"></i>
                    </span>
                  </p>
                </div>
                <div className="field">
                  <p className="control has-icons-left">
                    <input className="input" type="password" placeholder="Password" value={this.state.password}
                        onChange={(e) => this.setState({password: e.target.value})} />
                    <span className="icon is-small is-left">
                      <i className="fas fa-lock"></i>
                    </span>
                  </p>
                </div>
                <div className="field">
                  <p className="control">
                    <button type="submit" className="button button is-blue-gem-2 is-fullwidth is-medium" onClick={() => this.signIn()}>
                      Sign in
                    </button>
                  </p>
                </div>
                <div className="field">
                  <div className="control">
                    <p className="control has-text-centered">
                      <NavLink to="/password/reset">Forgot password?</NavLink>
                    </p>
                  </div>
                </div>
                <div className="field">
                  <div className="control">
                    <p className="control has-text-centered">
                      Don't have an account? <NavLink to="/register">Get started now!</NavLink>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>)
  }
}


const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    login: login
  }, dispatch)
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/containers/Login.js